module.exports = __webpack_public_path__ + "img/lunch_title--forbid.258ec740.png";